<template>
  <AppModal
    :title="$t('title.testSmtp')"
    content-class="smtp-dialog"
    position="right"
    is-open
    show-close-btn
    no-maximized
    @close="$emit('close')"
  >
    <div class="q-py-lg q-px-xl">
      <AppInput
        v-model="email"
        :class="['q-mb-xs', { valid: showHint, invalid: showError }]"
        :rules="[$options.rules.EMAIL]"
        :label="$t('label.email')"
      />
      <div
        v-if="isSent"
        v-t="$t(isValid ? 'text.emailSentSuccessfully' : 'text.emailSentFailed')"
        :class="['text-13-400', isValid ? 'text-primary': 'text-negative']"
      />
    </div>
    <template #footer>
      <div class="q-pa-lg border-top flex full-width">
        <AppButton
          :label="$t('button.cancel')"
          color="white"
          class="text-21-700 q-mr-md"
          text-color="black"
          outline
        />
        <AppButton
          :label="$t('button.sendTestMessage')"
          :loading="loading"
          color="primary"
          class="text-21-700 col"
          text-color="black"
          @click="onTest"
        />
      </div>
    </template>
  </AppModal>
</template>

<script>
import AppInput from 'common/components/AppInput';
import AppModal from 'common/components/AppModal';
import AppButton from 'common/components/buttons/AppButton';
import handleError from 'common/helpers/handleError';
import rules from 'common/helpers/rules';

export default {
  name: 'SmtpTestFormDialog',
  rules,
  components: {
    AppButton,
    AppInput,
    AppModal,
  },
  props: {
    smtp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      email: undefined,
      loading: false,
      isValid: false,
      isSent: false,
    };
  },
  computed: {
    showHint() {
      return this.isSent && this.isValid;
    },
    showError() {
      return this.isSent && !this.isValid;
    },
  },
  watch: {
    email() {
      this.reset();
    },
  },
  methods: {
    async onTest() {
      try {
        this.loading = true;
        await this.$axios.post(`smtp/${this.smtp.guid}/test`, {
          email: this.email,
        });
        this.isValid = true;
      } catch (error) {
        handleError(error);
      } finally {
        this.isSent = true;
        this.loading = false;
      }
    },
    reset() {
      this.isSent = false;
      this.isValid = false;
    },
  },
};
</script>

<style scoped lang="scss">
.valid {
  ::v-deep {
    .q-field__control::after {
      border-color: $primary !important;
    }
    input {
      color: $primary;
    }
  }
}

.invalid {
  ::v-deep {
    .q-field__control::after {
      border-color: $negative !important;
    }
    input {
      color: $negative;
    }
  }
}
</style>

<style lang="scss">
.smtp-dialog {
  width: 527px;
  max-height: calc(100vh - 96px);
}
</style>
